import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Text } from '@mentimeter/ragnar-ui/text';
import { StarSolidIcon } from '@mentimeter/ragnar-visuals';
import { useTranslations } from '@mentimeter/i18n';

interface RecommendedHeaderProps {
  planId: string;
}

export function RecommendedHeader({ planId }: RecommendedHeaderProps) {
  const t = useTranslations('plansContentPackage');
  return (
    <Box
      key={planId + '-top-header'}
      bg="positive"
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="100%"
      p="space2"
      borderTopLeftRadius="3xl"
      borderTopRightRadius="3xl"
      flexDirection="row"
    >
      <Box mb="1px">
        <StarSolidIcon color="onPositive" />
      </Box>
      <Text fontSize="87.5" ml="space1" color="onPositive">
        {t('plans.recommended')}
      </Text>
    </Box>
  );
}
